import React,{useState} from 'react'
import './DetailsCityComp.css';
import {Grid} from '@mui/material';

const DetailsCityComp = () => {

    var arr=['Miami','Chicago','London','New york','Mumbai','Dubai','Jeddah','Sydney','Istanbul']
    const [windowWidth, setWindowWidth] = useState(window.outerWidth);

    window.addEventListener('resize',function (){
      setWindowWidth(window.outerWidth)
    })

    return (
    <div className='DetailsCityCompMain'>
        <p style={{fontWeight:700,fontSize:22,textAlign:'left'}}>The Asset Operates in</p>
        <Grid container>
            {
                arr.map((v)=>(
                    <Grid item xs={windowWidth>360 ? 4 : 6} sm={2.4} md={windowWidth>915 ? 1.5 : 2} xl={1} lg={1.3} >
                        <div  className='detailsCitySubDiv'>
                        {v}
                        </div>
                    </Grid>

                ))
            }
        </Grid>
    </div>
  )

}

export default DetailsCityComp